/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const logs = r => require.ensure([], () => r(require('./components/index')), 'logs');
export default [    
    {
        name: 'logs',
        path: '/logs/index',
        component: logs,
    },
 ]



// WEBPACK FOOTER //
// ./src/app/logs/routes.js